var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGiftcardPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19.692,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.692H2c-1.104 0-2-.882-2-1.969V5.908c0-1.087.896-1.97 2-1.97h1.626l.078.28a4.65 4.65 0 00.95 1.69H2.5c-.276 0-.5.22-.5.492v5.415h20V6.4a.496.496 0 00-.5-.492h-2.154a4.63 4.63 0 001.029-1.97H22c1.104 0 2 .883 2 1.97v11.815c0 1.087-.896 1.97-2 1.97zM2 14.77v2.462c0 .272.224.492.5.492h19c.276 0 .5-.22.5-.492v-2.462zm8.911-4.923H8c.584-1.336 1.295-2.788 2-3.938-.647-.001-1.572.007-2 0-2.101-.035-2.987-1.778-3-2.954A2.95 2.95 0 018 0c1.499.006 2.814.859 4 2.277C13.186.86 14.501.006 16 0a2.95 2.95 0 013 2.954c-.013 1.176-.899 2.92-3 2.954-.428.007-1.353-.001-2 0 .739 1.18 1.491 2.73 2 3.938h-2.911c-.241-1.219-.7-2.611-1.089-3.332-.388.721-.902 2.356-1.089 3.332zM8.358 1.971c-1.131 0-1.507 1.889.12 1.968.237.011 2.235 0 2.235 0C9.676 2.52 9.193 1.97 8.358 1.97zm7.271 0c1.131 0 1.507 1.889-.12 1.968-.237.011-2.222 0-2.222 0 1.037-1.418 1.507-1.968 2.342-1.968z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

export default SvgGiftcardPage;